export default "__VITE_ASSET__BQkc$hh___"